import React, { Component } from 'react';
import { Configurator } from './configurator';
import { connect } from 'react-redux';
import { combineStates, configuratorDispatcher, configuratorState, currentNodeState, siteSettingsState, identityState, popupDispatcher, combineDispatchers,productsDispatcher, currentPageState, currentPageDispatcher } from '../../../store';
import { configurationSource, deflateModelVariables, getUserAssignments, isIE, retrieveChildTemplate as retrieveChildTemplates,apiException } from '../../../util';
import { PropTypes } from 'prop-types';
import { BusyContainer } from '../../../components';
import { configuratorActions, flagActions, productActions, superCodeActions } from '../../../services';
let isBusy=true;
export class ConfiguratorPageComponent extends Component {

  constructor(){
    super()
    this.state = {
      isBusy:true
    }
  }
  getChildContext() {
    const { modelToLoad, product, properties } = this.props;
    return {
      modelToLoad: modelToLoad || product.modelToLoad,
      properties: properties || this.context.properties
    };
  }

  componentDidMount() {
    if(this.props.currentPage.currentPage!=="configuratorPage" && !this.props.fromModelConfiguratorSelector){
      this.props.setPage("configuratorPage")
    }

    if(this.props.fromModelConfiguratorSelector && (this.props.showOnlyAccessoriesList || this.props.showOnlyFooter)){
      return;
    }
    this.resetConfiguration( this.props );
  }

  componentDidUpdate( prevProps ) {
    // isSuperCode will be true when previous search and current search values are supercodes
    const isSuperCode = prevProps?.superCodeSearchValue && this.props?.superCodeSearchValue;
    // isSuperCodeUpdated will be true if previous searched supercode value is not strictly equal to current searched supercode value
    const isSuperCodeUpdated = isSuperCode && prevProps?.superCodeSearchValue !== this.props?.superCodeSearchValue;
    // isSecondSearchSuperCode will be true when the previous searched value is main breaker and current searched value is supercode
    const isSecondSearchSuperCode = !isSuperCode && !prevProps?.superCodeSearchValue && !!this.props?.superCodeSearchValue;
    
    if(this.props.fromModelConfiguratorSelector && (this.props.showOnlyAccessoriesList || this.props.showOnlyFooter)){
      return;
    }

    if ( prevProps.product.name !== this.props.product.name || isSuperCodeUpdated || isSecondSearchSuperCode ) {
      this.resetConfiguration( this.props );
    }
  }

  // This method is to update the configuration when opening configuration page.
  // When called from search result there is no filterselector, so removed the check based on filterselector.  
  // Meaning configuration must be updated if configuration object is present.
  setSelectorValues( configuration ) {
    const { filterSelectors } = this.props;

    if ( !configuration) {
      return null;
    }
    let template;
    let firstTemplate = configuration.configuration?.children?.firstOrDefault();
    if(firstTemplate){
      template=configuration.configuration?.children?.first().childTemplate;
    }
    else{
      template=configuration;
    }
    // template = configuration.configuration?.children?.first().childTemplate|| configuration;
    const variables = deflateModelVariables( template.model );
    const selectorAssignments = (filterSelectors) ? filterSelectors.reduce( ( accumulator, filter ) => {
      const selectedValue = filter.values.find( value => value.isSelected );
      //TODO use more generic way
      const key = filter.identifier.replace( /^variants./i, '' ).replace( /_SACE$/, '' );
      const foundVariable = variables.find( variable => variable.fullyQualifiedName === key );

      if ( selectedValue && foundVariable ) {
        const valueName = selectedValue.name;
        const foundValue = foundVariable.values.any( value => value.name === valueName );
        return foundValue ? accumulator.concat( { key, value: valueName } ) : accumulator;
      }
      return accumulator;
    }, [] ): [];

    const productAssignments = configuration.assignments?.filter( a => variables.find( v => v.fullyQualifiedName === a.Key ) );
    const frameSize=this.props?.configurations?._active && this.props?.configurations?._active[0]?.assignments?.find(a=>a.Key=='TAGLIA')?.Value;
    if(frameSize && configuration.productModelType==0){
      const frame_key=variables.find(vari=>vari.properties?.isFrameSize==true)?.fullyQualifiedName;
      selectorAssignments.push( { key: frame_key, value: frameSize+'.2' } );
    }
    return this.fromTemplate( template, [...productAssignments, ...selectorAssignments] );
  }

  setFromPresets( productTemplate, product, mappedPresets ) {
    const templates = retrieveChildTemplates( productTemplate );
    const presets = [...mappedPresets];
    return templates.map( template => this.setVariant( product.code, template, presets ) );
  }

  mapProductPresets = product => product.preset.map( p => ( { identifier: p.variableName, values: [{ name: p.valueName, isSelected: true }],looseacc:p.looseacc,configuredAcc
:p.configuredAcc
} ) );

  mapHierarchyPresets = ( presets, product ) => presets.map( p => ( 
    { identifier: p.name, values: [{name: p.value.startsWith( '=' ) ? product[p.value.replace( '=', '' )] : p.value, isSelected: true }] } ) );

  setVariant( variantCode, configuration, presets = [] ) {
    const { filterSelectors = [], properties = {}, siteSettings, user } = this.props;
    if ( !configuration || !variantCode ) {
      return null;
    }
    const variantProperty = properties.settings && properties.settings.variantProperty;
    const defaultAssignments = [...getUserAssignments( configuration )];
    const variables = deflateModelVariables( configuration.model );
    const frameVariable= variables.find(vari=>vari.properties?.isFrameSize==true)?.fullyQualifiedName;
    let preset=[]
    let finalpreset=[]
    if(configuration.productModelType!=0){
       preset=presets.filter(p=>!p.looseacc)
    }
    if(configuration.productModelType==0){
       finalpreset=presets;
    }
    else{
      finalpreset=preset
    }
    let assignments={} //assignments will vary based on model type
    const frameSize=this.props?.configurations?._active && this.props?.configurations?._active[0]?.assignments?.find(a=>a.Key=='TAGLIA')?.Value;
    let  bomAssignment =[];
    if(configuration.productModelType==0){
     assignments = filterSelectors.concat( finalpreset ).reduce( ( selectorAssignments, filter ) => {
      const selectedValue = filter.values.find( value => value.isSelected );
      const modelAssignment = defaultAssignments.find( assignment => assignment.key === filter.identifier );
      if ( !modelAssignment && selectedValue ) {
        //const foundVariable = variables.find( variable => variable.fullyQualifiedName.split('.')[1] === filter.identifier );
        const foundVariable = (variables.find( variable =>variable.fullyQualifiedName.split('.')[1] === filter.identifier && variable.values.any(val=>val.name===selectedValue.name))) ||
            (variables.find( variable =>variable.fullyQualifiedName.split('.')[1] === filter.identifier.split('.')[1] && variable.values.any(val=>val.name===selectedValue.name)))||
            (variables.find( variable =>variable.name === filter.identifier && variable.values.any(val=>val.name===selectedValue.name)));
        if ( foundVariable && ( !foundVariable.assignedValue || foundVariable.assignedValue.name !== selectedValue.name ||foundVariable.values.length <=1 ) ) {
          if(filter.identifier!="Selector.Variant"){
          
            //  if(filter.identifier.indexOf('Grp')>-1){
            // selectorAssignments.push( { key: filter.identifier, value: selectedValue.name  } )
            // }
             if(filter.identifier.indexOf('.')>-1){
              selectorAssignments.push( { key: 'Accessories.'+filter.identifier.split('.')[1], value: selectedValue.name  } );
            }
            else if(foundVariable.fullyQualifiedName.split('.').length>=3){
              selectorAssignments.push( { key: foundVariable.fullyQualifiedName, value: selectedValue.name  } );
            }
            else{
            selectorAssignments.push( { key: 'Accessories.'+filter.identifier, value: selectedValue.name  } )}
            //selectorAssignments.push( { key: 'Accessories.'+filter.identifier, value: selectedValue.name } )
          }
          else if(filter.identifier=="Selector.Variant" && selectedValue.name == variantCode ){
          selectorAssignments.push( { key: filter.identifier, value: selectedValue.name } )}
           ;
        }
      }
      return selectorAssignments;
    }, [] );
  }
  else{
     assignments = filterSelectors.concat( finalpreset ).reduce( ( selectorAssignments, filter ) => {
      const selectedValue = filter.values.find( value => value.isSelected );
      const modelAssignment = defaultAssignments.find( assignment => assignment.key === filter.identifier );
      if ( !modelAssignment && selectedValue && !configuration.materialKey.startsWith('ACC_VD4') ) {
        const foundVariable = variables.find( variable => variable.fullyQualifiedName === filter.identifier );
        if ( foundVariable && ( !foundVariable.assignedValue || foundVariable.assignedValue.name !== selectedValue.name ) ) {
          if(filter.identifier!="Selector.Variant"){
            selectorAssignments.push( { key: filter.identifier, value: selectedValue.name } )
          }
          else if(filter.identifier=="Selector.Variant" && selectedValue.name == variantCode ){
          selectorAssignments.push( { key: filter.identifier, value: selectedValue.name } )}
           ;
        }
      }
      if(selectedValue && filter.configuredAcc && configuration.materialKey!=="ACC_EMAX2"){
        const foundVariable = variables.find( variable => variable.fullyQualifiedName === filter.identifier );
        if(foundVariable){
          if(filter.identifier!="Selector.Variant"){
            bomAssignment.push( { key: filter.identifier, value: selectedValue.name } )
          }
          else if(filter.identifier=="Selector.Variant" && selectedValue.name == variantCode ){
            bomAssignment.push( { key: filter.identifier, value: selectedValue.name } )}
        }
      }
      return selectorAssignments;
    }, [] );
  }
   
    if ( variantProperty ) {
      assignments.push( { key: variantProperty, value: variantCode } );
    } else if ( variables.any( variable => variable.fullyQualifiedName === 'Selector.Variant' ) ) {
      assignments.push( { key: 'Selector.Variant', value: variantCode } );
      if( siteSettings.filterBasedOnCountryAvailability && variables.any( variable => variable.fullyQualifiedName === 'Availability.LSO' ) ){
        assignments.push( { key: 'Availability.LSO', value: user.country } );
      }
    }
    else if(frameSize && frameVariable && configuration.productModelType==0){
      assignments.push( { key: frameVariable, value: frameSize+'.2' } );
    }

    if(this.props.selectedAccessorySelections?.length>0){
      return this.fromTemplate( configuration, assignments, this.props.selectedAccessorySelections );
    }

    return this.fromTemplate( configuration, assignments ).then(data=>{
      if(bomAssignment && bomAssignment.length>0 ){
        return this.fromTemplate( configuration, bomAssignment )
      }
      });
  }

  setPreselectedValues( configuration ) {
    if ( !configuration ) {
      return null;
    }
    const assignmentsDict = configuration.assignments.reduce( ( accumulatorDict, currentAssignment ) => {
      accumulatorDict[currentAssignment.Key || currentAssignment.key] = currentAssignment.Value || currentAssignment.value;
      return accumulatorDict;
    }, {} );
    // adding preselections to existing assignments
    // this way complete configuration is understood to be done first time
    // not as a delta 
    var existingassignments = getUserAssignments( configuration ).filter( assignment => assignmentsDict[assignment.key] !== assignment.value );
    configuration.assignments.push( ...existingassignments );
    return this.fromTemplate( configuration, [] );
  }

  getConfigurations() {
    const { configurations, product } = this.props;
    const configuration = configurations[product.name];
    return configuration && Object.values( configuration );
  }

  getConfiguration( materialKey ){
    const configurations = this.getConfigurations();
    const configuration = configurations.firstOrDefault( configuration => {
      if( configuration?.configuration?.children.length === 0 ) {
        return configuration.materialKey === materialKey;
      }
      else if(!configuration.configuration){
        return configuration.materialKey==materialKey;
      }
      return configuration.configuration?.children[0].key === materialKey 
    });
    return configuration;
  }

  resetConfiguration = props => {
    if ( !props ) {
      props = this.props;
    }

    const { currentNode, modelToLoad, product, filterSelectors } = props;
    this.props.productsClear();
    const model = modelToLoad || product.modelToLoad;
    const additionalVariants = product.additionalProducts && product.additionalProducts.map( prd => prd.name);
    const loadProduct = model
      ? this.props.loadComplexProduct( product, model )
      : this.props.loadProduct( product, filterSelectors || product.filterSelectors, null , additionalVariants );

    return loadProduct.then( () => {
      if ( product.configuration ) {
        let codes=[];
          if(product.configuration.productModelType==1 ){
            if( product.configuration.configuration && product.configuration.configuration.children ){
              product.configuration.configuration.children.forEach((child)=>{
                if(child.childTemplate.model &&child.childTemplate.model.children){
                  child.childTemplate.model.children.forEach((childModel)=>{
                    if(childModel.variables){
                      childModel.variables.forEach((variable)=>{
                        variable.values.forEach((value)=>{
                          if(value.title!='DO NOT DISPLAY'){
                           codes.push(value.name);
                         }
                        })
                      })
                    }
                  })
                }
              })
            }
            // variables mapped under product.configuration.model
            if(product.configuration.model && product.configuration.model.children){
              product.configuration.model.children.forEach((childModel)=>{
                  if(childModel.variables){
                    childModel.variables.forEach((variable)=>{
                      variable.values.forEach((value)=>{
                        if(value.title!='DO NOT DISPLAY'){
                         codes.push(value.name);
                       }
                      })
                    })
                  }
                })
          }

          
          this.props.getProducts(codes).then(()=>{
            this.props.productsCheck(true)
            isBusy=false;
            this.setState({isBusy:false})
          })
        }
        else if(product.configuration.productModelType==0){
            if( product.configuration.model && product.configuration.model.children ){
              product.configuration.model.children.forEach((child)=>{
                    if(child.variables){
                      child.variables.forEach((variable)=>{
                        variable.values.forEach((value)=>{
                          if(value.title!='DO NOT DISPLAY'){
                           codes.push(value.name);
                         }
                        })
                      })
                    }
    
                
              })
            }

          
          this.props.getProducts(codes).then(()=>{
            this.props.productsCheck(true)
            isBusy=false;
            this.setState({isBusy:false})
          })
        }
        if(product.looseadditionalProduct){
          return this.setPreselectedValues( product.configuration ).then(
            product.looseadditionalProduct && product.looseadditionalProduct.map( additional => this.setPreselectedValues( additional.configuration ) ));
        }
        else{
        return this.setPreselectedValues( product.configuration ).then(
        product.additionalProducts && product.additionalProducts.map( additional => this.setPreselectedValues( additional.configuration ) ));
      }}
      let productConfigurations = this.getConfigurations();
      let codes=[];
      if(productConfigurations.length === 0 || productConfigurations ===null){
        apiException({data:null}, this.props.dispatch, this.props.hidePopup, true)
      }
      if(productConfigurations){
        if(productConfigurations[0]?.productModelType==1 ){
        productConfigurations.forEach((productConfiguration)=>{
          if(productConfiguration.configuration && productConfiguration.configuration.children){
            if(productConfiguration.configuration.children.length>0){
              productConfiguration.configuration.children.forEach((child)=>{
                if(child.childTemplate.model &&child.childTemplate.model.children){
                  child.childTemplate.model.children.forEach((childModel)=>{
                    if(childModel.variables){
                      childModel.variables.forEach((variable)=>{
                        variable.values.forEach((value)=>{
                          if(value.title!='DO NOT DISPLAY'){
                           codes.push(value.name);
                         }
                        })
                      })
                    }
                  })
                }
              })
            }
            else{
              if(productConfiguration.model &&productConfiguration.model.children){
                // productConfiguration.model.children.forEach((childModel)=>{
                //   if(childModel.variables){
                //     childModel.variables.forEach((variable)=>{
                //       variable.values.forEach((value)=>{
                //         if(value.title!='DO NOT DISPLAY'){
                //          codes.push(value.name);
                //        }
                //       })
                //     })
                //   }
                // })
                const variables = deflateModelVariables( productConfiguration.model );
                if(variables){
                  variables.forEach((variable)=>{
                    variable.values.forEach((value)=>{
                      if(value.title!='DO NOT DISPLAY' && value.name.includes("1SDA")){
                        codes.push(value.name);
                      }
                    })
                  })
                }
              }
            }
        }
        //checking the model if the configuration property is missing(Emax2 LA)
          else if(productConfiguration.model && productConfiguration.model.children && productConfiguration.model.children[0]){
          productConfiguration.model.children[0].children.forEach((childModel)=>{
            if(childModel.variables){
              childModel.variables.forEach((variable)=>{
                variable.values.forEach((value)=>{
                  if(value.title!='DO NOT DISPLAY'){
                   codes.push(value.name);
                 }
                })
              })
            }
          })
        }
      })
      
      this.props.getProducts(codes).then(()=>{
        this.props.productsCheck(true)
        isBusy=false;
        this.setState({isBusy:false})
      })
    }
    else if(productConfigurations[0]?.productModelType==0){
      productConfigurations.forEach((productConfiguration)=>{
        if(productConfiguration.model && productConfiguration.model.children && productConfiguration.model.children[0]){
          productConfiguration.model.children[0].children.forEach((childModel)=>{
            if(childModel.variables){
              childModel.variables.forEach((variable)=>{
                variable.values.forEach((value)=>{
                  if(value.title!='DO NOT DISPLAY'){
                   codes.push(value.name);
                 }
                })
              })
            }
          })
        }
          if(productConfiguration.model && productConfiguration.model.children){
          productConfiguration.model.children.forEach((child)=>{
                if(child.variables){
                  child.variables.forEach((variable)=>{
                    variable.values.forEach((value)=>{
                      if(value.title!='DO NOT DISPLAY'){
                       codes.push(value.name);
                     }
                    })
                  })
                } 
          })
        }
      })
      
      this.props.getProducts(codes).then(()=>{
        this.props.productsCheck(true)
        isBusy=false;
        this.setState({isBusy:false})
      })
    }
    else{
      this.props.productsCheck(false);
      isBusy=false;
      this.setState({isBusy:false})
    }
    }
      if ( product.preset && product.preset.any() ) {
        return this.setFromPresets( productConfigurations, product, this.mapProductPresets( product ) );
      }

      if( currentNode.preFilters && currentNode.preFilters.preset.any() ) {
        return this.setFromPresets( productConfigurations, product, this.mapHierarchyPresets( currentNode.preFilters.preset, product ) );
      }

      if ( productConfigurations.any( configuration => configuration.configuration?.hasChildren ) ) {
        return productConfigurations.map( configuration => this.setSelectorValues( configuration ) );
      }

      return productConfigurations.map( configuration => this.setVariant( product.name, configuration ) );
    } ).then( () => {
      // remove if ie support is not needed
      if ( isIE() ) {
        const dropdownElement = window.document.getElementsByClassName( 'rw-dropdown-list-input' )[0];
        dropdownElement && dropdownElement.click();
        dropdownElement && dropdownElement.click();
      }
    } );
  }

  getConfigurationSource( configuration ) {
    return configuration.productModelType === 0 ? configurationSource.model : configurationSource.accessories;
  }

  fromTemplate( template, assignments, selectedAccessorySelections ) {
    const configuration = this.getConfiguration( template.materialKey );
    let newAssignments = assignments.sort( ( a, b ) => a.key > b.key ? 1 : -1 );
    if(selectedAccessorySelections){
      for(let e of selectedAccessorySelections){
        newAssignments.push(e);
      }
    }
    return this.props.fromTemplate( configuration, template, newAssignments, this.props.product.name )
    .then(data=>{
      this.props.setMainProductChanged && this.props.setMainProductChanged(true);
    }).catch((err) => {
      console.log("err",err)
      apiException({data:null}, this.props.dispatch, this.props.hidePopup, true)});
  }

  assignValue = ( template, variable, value, fqn, index ) => {
    const { product } = this.props;
    const configuration = this.getConfiguration( template.materialKey );
    const source = this.getConfigurationSource( configuration );
    this.props.updatePopup(true);
    this.props.handleSelectedAccessorySelections && this.props.handleSelectedAccessorySelections({key:source === configurationSource.model ? fqn : variable, value:value, index:index}, "add");
    return this.props.assignValue( configuration, template, source === configurationSource.model ? fqn : variable, value, product.name );
  }

  removeValue = ( template, variable, value, fqn ) => {
    const configurations = this.getConfigurations();
    const configuration = this.getConfiguration( template.materialKey );
    const source = this.getConfigurationSource( configuration );
    this.props.updatePopup(true);
    this.props.handleSelectedAccessorySelections && this.props.handleSelectedAccessorySelections({key:source === configurationSource.model ? fqn : variable, value:value}, "remove");
    return this.props.removeValue( configuration, template, source === configurationSource.model ? fqn : variable, value, this.props.product.name );
  }

  render() {
    const { className, fromCart, isPopup, oldProduct, filterSelectors, assemblyType, product,superCodeSearchValue,currentNode,fromSearch } = this.props;
    let selectorName = currentNode.selectorName;
    const cartID= configuration && oldProduct ? oldProduct.cartID : product &&  product.cartID;
    const clonedIdx = configuration && oldProduct ? oldProduct.clonedIdx : product &&  product.clonedIdx;
    let configuration = this.getConfigurations();
    if( configuration ){
      const amount = configuration && oldProduct ? oldProduct.amount : product &&  product.amount;
      configuration = configuration.map( c => {  return {...c,product:{ ...c.product, filterSelectors:  filterSelectors ? filterSelectors : oldProduct && oldProduct.filterSelectors, amount: amount,configurableProduct:product.configurableProduct,bom:fromCart?product.bom:product.bomItems,FG:product.superCodeLSO,superCode:product.superCode,cartID:cartID,clonedIdx:clonedIdx } }});
      return <Configurator
      configuration={ configuration }
      className={ className }
      fromCart={ fromCart }
      isPopup={ isPopup }
      oldProduct={ ( fromCart && { ...oldProduct } ) }
      resetConfigurator={ this.resetConfiguration }
      assignValue={ this.assignValue }
      removeValue={ this.removeValue }
      assemblyType = { assemblyType }
      superCodeSearchValue={superCodeSearchValue}
      currentNode={currentNode}
      fromSearch={fromSearch}
      productsAvailable={this.props.configurations.productsAvailable}
      isBusy={this.state.isBusy}
      selectorName = {selectorName}
      fromModelConfiguratorSelector = {this.props.fromModelConfiguratorSelector}
      showOnlySelectors = {this.props.showOnlySelectors}
      showOnlyAccessoriesList = {this.props.showOnlyAccessoriesList}
      showOnlyFooter = {this.props.showOnlyFooter}
      isEdit={this.props.isEdit}
      mainProductChanged = {this.props.mainProductChanged}
      selectedAccessorySelections = {this.props.selectedAccessorySelections}
      handleSelectedAccessorySelections = {this.props.handleSelectedAccessorySelections}
    />;
    }
    return<BusyContainer 
    actions={ 
      [
        configuratorActions.ASSIGN,
        configuratorActions.RESET,
        configuratorActions.REMOVE,
        configuratorActions.LOADED,
        configuratorActions.FROMTEMPLATE,
        superCodeActions.CREATE,
        productActions.GET,
        productActions.LOAD,
        flagActions.ADDING,
        'filter-active'
      ]
    } > <div className="abb-configurator" /></BusyContainer>;
  }
}

ConfiguratorPageComponent.propTypes = {
  assignValue: PropTypes.func.isRequired,
  className: PropTypes.string,
  configurations: PropTypes.shape( {} ),
  filterSelectors: PropTypes.arrayOf( PropTypes.shape( {} ) ),
  fromCart: PropTypes.bool,
  fromTemplate: PropTypes.func.isRequired,
  isPopup: PropTypes.bool,
  loadComplexProduct: PropTypes.func.isRequired,
  loadProduct: PropTypes.func.isRequired,
  oldProduct: PropTypes.shape( {} ),
  product: PropTypes.shape( {} ),
  removeValue: PropTypes.func.isRequired
};

ConfiguratorPageComponent.childContextTypes = {
  modelToLoad: PropTypes.string,
  properties: PropTypes.shape( {} )
};

ConfiguratorPageComponent.contextTypes = {
  properties: PropTypes.shape( {} )
};

export const ConfiguratorPage = connect( combineStates( configuratorState, currentNodeState, siteSettingsState, identityState, currentPageState ), combineDispatchers(configuratorDispatcher, popupDispatcher,productsDispatcher, currentPageDispatcher) )( ConfiguratorPageComponent );